import React, { useEffect, useRef, useState } from 'react';

export const ANNUAL_PRODUCT_ID = 5594926;

// Verifies the e-mail against the annual plan (Hotmart product 5594926) and
// stores the token the e-book apps read for direct access.
const AnnualAccessModal = ({ initialEmail = '', onClose, onVerified }) => {
  const [email, setEmail] = useState(initialEmail);
  const [isVerifying, setIsVerifying] = useState(false);
  const [message, setMessage] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const verify = async (e) => {
    e.preventDefault();
    setIsVerifying(true);
    setMessage(null);

    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, productId: ANNUAL_PRODUCT_ID }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('ebook_annual_token', data.token);
        localStorage.setItem('ebook_annual_email', email);
        localStorage.setItem('ebook_annual_access', 'true');
        localStorage.setItem('ebook_product_id', String(ANNUAL_PRODUCT_ID));
        localStorage.setItem('ebook_access_type', 'annual');

        setMessage({ type: 'success', text: 'Acesso verificado! Você já pode ler todos os nossos eBooks.' });
        onVerified(email);
        setTimeout(onClose, 2000);
      } else {
        setMessage({ type: 'error', text: 'E-mail não encontrado ou sem plano anual associado.' });
      }
    } catch (error) {
      console.error('Error verifying annual access:', error);
      setMessage({ type: 'error', text: 'Não foi possível verificar agora. Tente novamente em instantes.' });
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div
      className="dd-modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="dd-modal" role="dialog" aria-modal="true" aria-labelledby="annual-modal-title">
        <button type="button" className="dd-modal-close" onClick={onClose} aria-label="Fechar">
          ×
        </button>
        <h3 id="annual-modal-title">Verificar acesso anual</h3>
        <p>Informe o e-mail usado na compra do plano anual para liberar todos os eBooks.</p>

        {message && (
          <div className={`dd-form-message dd-form-message--${message.type}`} role="status">
            {message.text}
            {message.type === 'error' && (
              <a
                className="dd-btn dd-btn--primary dd-btn--block dd-modal-buy"
                href="https://dropsebook.com/en/ebook2/sales"
                target="_blank"
                rel="noopener noreferrer"
              >
                🛒 Assinar o plano anual
              </a>
            )}
          </div>
        )}

        <form onSubmit={verify}>
          <div className="dd-field">
            <label htmlFor="annualEmail">E-mail</label>
            <input
              ref={inputRef}
              id="annualEmail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              autoComplete="email"
              required
            />
          </div>
          <div className="dd-modal-actions">
            <button type="button" className="dd-btn dd-btn--secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="dd-btn dd-btn--primary" disabled={isVerifying}>
              {isVerifying ? 'Verificando…' : 'Verificar acesso'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnnualAccessModal;
